var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.report === 'general')?_c('general'):_vm._e(),(_vm.report === 'fundamentals')?_c('fundamentals'):_vm._e(),(_vm.report === 'parts')?_c('parts'):_vm._e(),(_vm.report === 'financial')?_c('economic-financial'):_vm._e(),(_vm.report === 'report')?_c('complete-validation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }